/* eslint-disable prettier/prettier */
import { useAccount, useMsal } from "@azure/msal-react"
import React, { createContext, useContext, useState } from "react"
import Swal from "sweetalert2";
import { detectCodMalicioso, sanitizeString } from "../util/util2";

export const AuthContext = createContext({})


export default function AuthProvider({ children }) {
    const [token, setToken] = useState();
    const [user, setUser] = useState();
    const [userPhoto, setUserPhoto] = useState();
    const [aplicacoes, setAplicacoes] = useState();
    const [permissoes, setPermissoes] = useState();
    const [perfis, setPerfis] = useState();
    const [dataExpiracao, setDataExpiracao] = useState();
    const [textosMaliciosos, setTextosMaliciosos] = useState("");
    const [routes, setRoutes] = useState([]);
    const [keys, setKeys] = useState({});

    const { instance, accounts } = useMsal()
    const account = useAccount(accounts[0] || {});

    const logoff = (message = "Não autorizado!") => {
        Swal.fire({
            title: "Acesso Negado!",
            text: message,
            icon: 'error',
        }).then(() => {
            localStorage.setItem("aux", null);
            localStorage.setItem("photo", null);
            setToken(null)
            setUser(null)
            setPerfis(null)
            setUserPhoto(null)
            instance.logoutRedirect();

        })
    }


    const renovaToken = async () => {
        let data = {
            scopes: ["User.Read"],
            account: account,
        }

        const aux = localStorage.getItem('aux');

        if (aux) {
            const exp = new Date(aux).getTime();
            const agora = Date.now();

            if (agora >= exp) {
                logoff();
                return;
            }

            const renovar = agora >= (exp - 110 * 60 * 1000);


            if (renovar) {
                data.forceRefresh = true;
                data.refreshTokenExpirationOffsetSeconds = 7200;
            }
        }

        await instance.acquireTokenSilent(data)
            .then(async (response) => {
                if (response) {

                    localStorage.setItem("aux", response.extExpiresOn);
                    await setToken(response)
                    setDataExpiracao(response.extExpiresOn)
                }
            });
    }

    const purify = (value) => {
        return sanitizeString(value, textosMaliciosos);
    }

    const detectXSS = (value) => {
        return detectCodMalicioso(value, textosMaliciosos);
    }

    return (
        <AuthContext.Provider
            value={{
                token, setToken,
                user, setUser,
                userPhoto, setUserPhoto,
                aplicacoes, setAplicacoes,
                permissoes, setPermissoes,
                perfis, setPerfis,
                dataExpiracao, setDataExpiracao,
                keys, setKeys,
                textosMaliciosos, setTextosMaliciosos,
                detectXSS, purify,
                routes, setRoutes,
                logoff, renovaToken
            }}>
            {children}
        </AuthContext.Provider>
    )
}
